var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15H6C5.44772 15 5 15.4477 5 16V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V16C19 15.4477 18.5523 15 18 15ZM6 13C4.34315 13 3 14.3431 3 16V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V16C21 14.3431 19.6569 13 18 13H6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6C5.44772 4 5 4.44772 5 5V8C5 8.55228 5.44772 9 6 9H18C18.5523 9 19 8.55228 19 8V5C19 4.44772 18.5523 4 18 4ZM6 2C4.34315 2 3 3.34315 3 5V8C3 9.65685 4.34315 11 6 11H18C19.6569 11 21 9.65685 21 8V5C21 3.34315 19.6569 2 18 2H6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 17.5C6.5 16.9477 6.94772 16.5 7.5 16.5H13C13.5523 16.5 14 16.9477 14 17.5C14 18.0523 13.5523 18.5 13 18.5H7.5C6.94772 18.5 6.5 18.0523 6.5 17.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6.5C6.5 5.94772 6.94772 5.5 7.5 5.5H13C13.5523 5.5 14 5.94772 14 6.5C14 7.05228 13.5523 7.5 13 7.5H7.5C6.94772 7.5 6.5 7.05228 6.5 6.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5C17.5 18.0523 17.0523 18.5 16.5 18.5C15.9477 18.5 15.5 18.0523 15.5 17.5C15.5 16.9477 15.9477 16.5 16.5 16.5C17.0523 16.5 17.5 16.9477 17.5 17.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5C17.5 7.05228 17.0523 7.5 16.5 7.5C15.9477 7.5 15.5 7.05228 15.5 6.5C15.5 5.94772 15.9477 5.5 16.5 5.5C17.0523 5.5 17.5 5.94772 17.5 6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.0d6e08f8aec78d73538299db8de3bc71.svg";
export { ForwardRef as ReactComponent };